import { takeLatest, put } from 'redux-saga/effects'
import Notification        from "../../components/commons/Notification"
import { auth }            from '../../Firebase'
import { push }            from 'connected-react-router'

import {
  LOGIN,
  LOGIN_FAIL,
  LOGOUT,
  LOGOUT_FAIL
} from './Constants'

function* shootFetchLogin(action) {

	const { email, password } = action.payload

	try {

		yield auth.signInWithEmailAndPassword(email, password)
		yield localStorage.setItem('userIsLoggedIn', 'true')
		yield put(push('/admin'))
		yield window.location.reload()

	} catch (error) {

		const wrongEmail    = 'auth/invalid-email'
		const wrongPassword = 'auth/wrong-password'
		const userNotFound  = 'auth/user-not-found'
		const userDisabled  = 'auth/user-disabled'
		const errorCode     = error.code
		const errorMessage  = error.message

		yield	put({type: LOGIN_FAIL, payload: errorMessage})

		switch (errorCode) {
			case wrongEmail:
				Notification(`${wrongEmail}: ${errorMessage}`, 'error') 
				break
			case wrongPassword:
				Notification(`${wrongPassword}: ${errorMessage}`, 'error')
				break
			case userNotFound:
				Notification(`${userNotFound}: ${errorMessage}`, 'error')
				break
			case userDisabled:
				Notification(`${userDisabled}: ${errorMessage}`, 'error')
				break
			default:
				break
		}
	}
}

function* shootFetchLogOut() {
	try {
		yield auth.signOut()
		yield localStorage.removeItem('userIsLoggedIn')
		yield put(push('/'))
	  yield window.location.reload()
	} catch (error) {
		const errorMessage = error.message
		yield Notification(errorMessage, 'error')
		yield put({ type: LOGOUT_FAIL })
	}
}

export default function* loginWatcher() {
  yield takeLatest(LOGIN, shootFetchLogin)
  yield takeLatest(LOGOUT, shootFetchLogOut)
}
